import { Checkbox } from 'components/Material/index'
import FormControlLabel from '@mui/material/FormControlLabel'
import { BodyText } from 'components/Custom/Typographies'
import { Box } from 'components/Material/Box'
import { FormHelperText } from 'components/Material/FormHelperText'
import { Control, Controller, Path, FieldValues } from 'react-hook-form'

type CheckBoxProps<T extends FieldValues> = {
  name: Path<T>
  label?: string
  disabled?: boolean
  control: Control<T>
  errorMessage?: string
}

export const CheckBoxController = <T extends FieldValues>({
  name,
  label,
  disabled,
  control,
  errorMessage
}: CheckBoxProps<T>) => {
  return (
    <Box>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <FormControlLabel
            className="w-full items-start"
            control={
              <Checkbox
                {...field}
                title={name || ''}
                checked={!!field.value}
                name={name}
                color="primary"
                disabled={disabled}
              />
            }
            sx={{
              '&.MuiFormControlLabel-root .MuiFormControlLabel-label ': { alignSelf: 'center' }
            }}
            label={
              <BodyText
                title={label || ''}
                text={label || ''}
                typeStyle="large"
                disabled={disabled}
                className="h-full"
              />
            }
            disabled={disabled}
          />
        )}
      />
      {errorMessage && <FormHelperText className="text-red-600">*{errorMessage}</FormHelperText>}
    </Box>
  )
}
